import React from 'react';
import PropTypes from 'prop-types';

import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';

import Typography from '@ts-core/components/Typography';
import TimeAgo from '@ts-core/components/TimeAgo';

const useStyles = makeStyles((theme) => ({
  userName: {
    marginRight: theme.spacing(1),
  },
  editedLabel: {
    marginLeft: theme.spacing(1),
    color: theme.palette.grey[500],
    fontWeight: '700',
  },
}));

const ForumItemInfo = (props) => {
  const classes = useStyles();
  const { user, createdAt: createdAtStr, loading, edited, className } = props;

  return (
    <Box display="flex" alignItems="flex-end" className={className}>
      <Typography className={classes.userName} color="secondary" variant="subtitle2" loading={loading} skeletonWidth={100} skeletonHeight={12}>
        {user?.name}
      </Typography>
      <Typography variant="caption" loading={loading} skeletonWidth={100} skeletonHeight={12}>
        <TimeAgo date={createdAtStr} />
      </Typography>
      {edited && (
        <Typography className={classes.editedLabel} variant="caption">
          Editado
        </Typography>
      )}
    </Box>
  );
};

ForumItemInfo.propTypes = {
  className: PropTypes.string,
  user: PropTypes.object,
  createdAt: PropTypes.string,

  edited: PropTypes.bool,
  loading: PropTypes.bool,
};

ForumItemInfo.defaultProps = {
  className: undefined,
  user: {},
  createdAt: undefined,
  edited: false,
  loading: false,
};

export default ForumItemInfo;
